import { Micdrop } from '@micdrop/web';

import api from '@/services/api';

/**
 * Pauses the interview conversation — mutes Micdrop VAD and pauses the client.
 * The FAB feedback recording (independent getUserMedia stream) is unaffected.
 */
export function pauseInterview(): void {
  Micdrop.mute();
  Micdrop.pause();
}

/**
 * Resumes the interview after a pause — unmutes VAD, resumes client,
 * and asks the backend to re-speak the last assistant question.
 * Fire-and-forget: errors are only logged so the user sees no disruption.
 */
export function resumeAfterPause(interviewId: string): void {
  Micdrop.unmute();
  Micdrop.resume();
  void api.post(`/calls/${interviewId}/resume`, {}).catch((error: unknown) => {
    console.warn('Failed to notify backend of resume', { interviewId, error });
  });
}
